window.ORDER_PAGE_EASYBUY_HELPERS = {
    async openEasyBuy(country = '') {

        if (!this.easyBuyEnabled || this.isUserLoggedIn || this.currServOpt === 'min') return false
        if (country && country !== this.currentCountry) {
            this.currentCountry = country
            await this.$nextTick()
        }
        if (!this.currentCountry) return false
        this.resetEasyBuyState()
        this.easyBuyRequested = true
        this.easyBuyStep = 2
        this.easyBuyCaptchaLoading = true
        await this.$nextTick()
        this.renderEasyBuyCaptcha()
        this.$refs.easyBuyBlock?.scrollIntoView?.({ behavior: 'smooth', block: 'center' })
        return true
    },

    resetEasyBuyState() {
        this.easyBuyRequested = false
        this.easyBuyStep = 0
        this.easyBuyEmailTouched = false
        this.easyBuyEmailVerificationPending = false
        this.easyBuyEmailCode = ''
        this.easyBuyCodeTouched = false
        this.easyBuyVerificationLoading = false
        this.easyBuyResendAvailable = false
        this.easyBuyResendLoading = false
        clearTimeout(this.easyBuyResendTimer)
        this.easyBuyResendTimer = null
        this.easyBuyCaptchaLoading = false
        this.easyBuyCaptchaReady = false
        this.easyBuyLoading = false
        this.easyBuyPaymentMethods = []
        this.easyBuySelectedPaymentMethod = null
        this.easyBuyStepError = ''
        this.easyBuyPaymentError = ''
        this.easyBuyOrderError = ''
        this.easyBuyOrder = null
        this.easyBuyPaymentStatusText = ''
        this.easyBuyInvoiceLoading = false
        this.easyBuyNumberCopied = false
        this.easyBuyTryAnotherLoading = false
        this.easyBuySmsWaitStartedAt = 0
        this.easyBuyTimerToView = '00:00'
        this.easyBuyWaitingStep = 0
        this.easyBuyWaitingSeconds = 60
        this.easyBuyWaitingChanging = false
        clearTimeout(this.easyBuyWaitingChangeTimer)
        this.stopEasyBuyOrderPolling()
        this.stopEasyBuyTimer()
        this.removeEasyBuyCaptcha()
    },

    touchEasyBuyEmail() { this.easyBuyEmailTouched = true },

    startEasyBuyResendTimer() {
        clearTimeout(this.easyBuyResendTimer)
        this.easyBuyResendAvailable = false
        this.easyBuyResendTimer = setTimeout(() => {
            this.easyBuyResendAvailable = true
            this.easyBuyResendTimer = null
        }, 60000)
    },

    async changeEasyBuyEmail() {
        this.easyBuyEmailVerificationPending = false
        this.easyBuyEmailCode = ''
        this.easyBuyCodeTouched = false
        this.easyBuyStepError = ''
        clearTimeout(this.easyBuyResendTimer)
        this.easyBuyResendTimer = null
        this.easyBuyResendAvailable = false
        this.easyBuyCaptchaLoading = true
        await this.$nextTick()
        this.renderEasyBuyCaptcha()
    },

    async openEasyBuyEmailStep() {
        this.easyBuyStep = 2
        this.easyBuyCaptchaLoading = true
        await this.$nextTick()
        this.renderEasyBuyCaptcha()
    },

    loadEasyBuyCaptchaScript() {
        if (window.turnstile?.render) return Promise.resolve(window.turnstile)
        if (window.__easyBuyTurnstilePromise) return window.__easyBuyTurnstilePromise
        window.__easyBuyTurnstilePromise = new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
            script.async = true
            script.defer = true
            script.onload = () => window.turnstile?.render ? resolve(window.turnstile) : reject(new Error('Turnstile loaded without render API'))
            script.onerror = () => reject(new Error('Unable to load Turnstile'))
            document.head.appendChild(script)
        })
        return window.__easyBuyTurnstilePromise
    },

    async renderEasyBuyCaptcha() {
        if (!this.easyBuyVisible || this.easyBuyStep !== 2) return
        await this.$nextTick()
        if (!this.$refs.easyBuyCaptchaContainer || this.easyBuyCaptchaWidgetId !== null) return
        this.easyBuyCaptchaLoading = true
        this.easyBuyCaptchaReady = false
        clearTimeout(this.easyBuyCaptchaRenderTimer)
        this.easyBuyCaptchaRenderTimer = null
        try {
            const turnstile = await this.loadEasyBuyCaptchaScript()
            if (!this.easyBuyVisible || this.easyBuyStep !== 2 || !this.$refs.easyBuyCaptchaContainer) {
                this.easyBuyCaptchaLoading = false
                return
            }
            const markCaptchaReady = () => {
                if (this.easyBuyCaptchaWidgetId === null) return
                clearTimeout(this.easyBuyCaptchaRenderTimer)
                this.easyBuyCaptchaRenderTimer = null
                this.easyBuyCaptchaReady = true
                this.easyBuyCaptchaLoading = false
            }
            this.easyBuyCaptchaWidgetId = turnstile.render(this.$refs.easyBuyCaptchaContainer, {
                sitekey: '0x4AAAAAAAO5nsUKHWxY4Xkt', theme: 'light',
                callback: (token) => { this.easyBuyCaptchaToken = token || ''; this.easyBuyCaptchaError = '' },
                'expired-callback': () => { this.easyBuyCaptchaToken = '' },
                'after-interactive-callback': markCaptchaReady,
                'error-callback': () => {
                    this.easyBuyCaptchaToken = ''
                    this.easyBuyCaptchaError = $L('ords.somethingWrong')
                    clearTimeout(this.easyBuyCaptchaRenderTimer)
                    this.easyBuyCaptchaRenderTimer = null
                    this.easyBuyCaptchaLoading = false
                },
            })

            // Fallback for older Turnstile builds that do not emit after-interactive-callback.
            // Keep it short: rendering the captcha must not hold up the form.
            this.easyBuyCaptchaRenderTimer = setTimeout(markCaptchaReady, 250)
        } catch (error) {
            console.error('Easy Buy Turnstile failed:', error)
            this.easyBuyCaptchaError = $L('ords.somethingWrong')
            this.easyBuyCaptchaLoading = false
        }
    },

    removeEasyBuyCaptcha(keepToken = false) {
        if (!keepToken) { this.easyBuyCaptchaToken = ''; this.easyBuyCaptchaError = '' }
        clearTimeout(this.easyBuyCaptchaRenderTimer)
        this.easyBuyCaptchaRenderTimer = null
        if (window.turnstile && this.easyBuyCaptchaWidgetId !== null) window.turnstile.remove(this.easyBuyCaptchaWidgetId)
        this.easyBuyCaptchaWidgetId = null
        this.easyBuyCaptchaReady = false
        this.easyBuyCaptchaLoading = false
    },

    resetEasyBuyCaptcha() {
        this.easyBuyCaptchaToken = ''
        if (window.turnstile && this.easyBuyCaptchaWidgetId !== null) window.turnstile.reset(this.easyBuyCaptchaWidgetId)
    },

    async reloadEasyBuyCaptcha() {
        this.removeEasyBuyCaptcha()
        this.easyBuyCaptchaLoading = true
        await this.$nextTick()
        return this.renderEasyBuyCaptcha()
    },

    async prepareEasyBuyOrder() {
        this.easyBuyEmailTouched = true
        if (!this.easyBuyCanOpenPaymentStep) return false
        if (!this.easyBuyCaptchaToken) { this.easyBuyCaptchaError = $L('ords.somethingWrong'); this.reloadEasyBuyCaptcha(); return false }
        this.easyBuySubmitting = true
        this.easyBuyStepError = ''
        try {
            const response = await axios.post('/api/easy_buy.php?method=SEND_EMAIL_VERIFICATION_CODE', {
                email: this.easyBuyEmailValue, recaptcha: this.easyBuyCaptchaToken,
                serviceOpt: this.currServOpt, country: this.currentCountry,
            })
            const payload = response?.data || {}
            if (payload.code !== 0 || !payload.data?.email_sent) throw new Error(payload.message || $L('ords.somethingWrong'))
            this.easyBuyEmailVerificationPending = true
            this.easyBuyEmailCode = ''
            this.easyBuyCodeTouched = false
            this.removeEasyBuyCaptcha()
            this.startEasyBuyResendTimer()
            return true
        } catch (error) {
            const message = error?.response?.data?.message || error.message || $L('ords.somethingWrong')
            await this.reloadEasyBuyCaptcha()
            if (/recaptcha|captcha/i.test(message)) this.easyBuyCaptchaError = $L('ords.somethingWrong')
            else this.easyBuyStepError = message
            return false
        } finally { this.easyBuySubmitting = false }
    },

    async verifyEasyBuyEmailCode() {
        this.easyBuyCodeTouched = true
        if (!this.easyBuyEmailCodeIsValid || this.easyBuyVerificationLoading) return false
        this.easyBuyVerificationLoading = true
        this.easyBuyStepError = ''
        try {
            const response = await axios.post('/api/easy_buy.php?method=VERIFY_EMAIL_AND_REGISTER', {
                email: this.easyBuyEmailValue, code: this.easyBuyEmailCode.trim(),
                serviceOpt: this.currServOpt, country: this.currentCountry,
            })
            const payload = response?.data || {}
            if (payload.code !== 0 || !payload.data?.registered) throw new Error(payload.message || $L('ords.somethingWrong'))
            const url = new URL(window.location.href)
            url.searchParams.set('service', this.currServOpt)
            url.searchParams.set('country', this.currentCountry)
            url.searchParams.set('easy_buy_registered', '1')
            url.searchParams.set('easy_buy_registration_notice', '1')
            const redirectAfterRegistration = () => window.location.assign(url.toString())

            if (typeof window.gtag === 'function') {
                let redirected = false
                const redirectOnce = () => {
                    if (redirected) return
                    redirected = true
                    redirectAfterRegistration()
                }

                window.gtag('event', 'easybuy_reg', {
                    event_callback: redirectOnce,
                    event_timeout: 500,
                })
                // Some GA configurations do not invoke event_callback. Never leave the user on this step.
                setTimeout(redirectOnce, 600)
            } else {
                redirectAfterRegistration()
            }
            return true
        } catch (error) {
            this.easyBuyStepError = error?.response?.data?.message || error.message || $L('ords.somethingWrong')
            return false
        } finally { this.easyBuyVerificationLoading = false }
    },

    async resendEasyBuyEmailCode() {
        if (!this.easyBuyResendAvailable || this.easyBuyResendLoading) return false
        this.easyBuyResendLoading = true
        this.easyBuyStepError = ''
        try {
            const response = await axios.post('/api/easy_buy.php?method=RESEND_EMAIL_VERIFICATION_CODE', {
                email: this.easyBuyEmailValue,
                serviceOpt: this.currServOpt,
                country: this.currentCountry,
            })
            const payload = response?.data || {}
            if (payload.code !== 0 || !payload.data?.email_sent) throw new Error(payload.message || $L('ords.somethingWrong'))
            this.easyBuyEmailCode = ''
            this.easyBuyCodeTouched = false
            this.startEasyBuyResendTimer()
            return true
        } catch (error) {
            this.easyBuyStepError = error?.response?.data?.message || error.message || $L('ords.somethingWrong')
            return false
        } finally { this.easyBuyResendLoading = false }
    },

    async openEasyBuyPaymentStep() {
        if (!this.easyBuyOrder) return false
        this.easyBuyStep = 4
        this.easyBuyLoading = true
        this.easyBuyPaymentError = ''
        try {
            const response = await axios.get('/api/easy_buy.php?method=GET_PAYMENT_METHODS')
            const payload = response?.data || {}
            if (payload.code !== 0) throw new Error(payload.message || 'Failed to load payment methods.')
            this.easyBuyPaymentMethods = payload.data?.methods || []
            if (this.easyBuyPaymentMethods.length) this.selectEasyBuyPaymentMethod(this.easyBuyPaymentMethods[0].id)
        } catch (error) { this.easyBuyPaymentError = error.message || 'Failed to load payment methods.' } finally { this.easyBuyLoading = false }
    },

    selectEasyBuyPaymentMethod(id) { this.easyBuySelectedPaymentMethod = id; this.easyBuyPaymentError = '' },

    async copyEasyBuyNumber() {
        const number = [this.easyBuyOrder?.phonecode, this.easyBuyOrder?.phonenumber].filter(Boolean).join(' ')
        if (!number) return false
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(number)
            } else {
                const input = document.createElement('textarea')
                input.value = number
                input.style.position = 'fixed'
                input.style.opacity = '0'
                document.body.appendChild(input)
                input.select()
                document.execCommand('copy')
                input.remove()
            }
            this.easyBuyNumberCopied = true
            clearTimeout(this.easyBuyCopyTimer)
            this.easyBuyCopyTimer = setTimeout(() => { this.easyBuyNumberCopied = false }, 1800)
            return true
        } catch (error) { return false }
    },

    updateEasyBuyTimer() {
        const seconds = Math.max(0, Number(this.easyBuyOrder?.expires_at || 0) - Math.floor(Date.now() / 1000))
        const minutes = String(Math.floor(seconds / 60)).padStart(2, '0')
        this.easyBuyTimerToView = `${minutes}:${String(seconds % 60).padStart(2, '0')}`
        this.updateEasyBuyWaitingMessage()
        return seconds
    },

    resetEasyBuyWaitingMessages() {
        clearTimeout(this.easyBuyWaitingChangeTimer)
        this.easyBuyWaitingStep = 0
        this.easyBuyWaitingSeconds = 60
        this.easyBuyWaitingChanging = false
    },

    updateEasyBuyWaitingMessage() {
        if (this.easyBuyOrder?.sms_ready) {
            this.resetEasyBuyWaitingMessages()
            return
        }
        if (this.easyBuyWaitingChanging) return
        if (this.easyBuyWaitingSeconds > 0) {
            this.easyBuyWaitingSeconds -= 1
            return
        }
        this.easyBuyWaitingChanging = true
        this.easyBuyWaitingChangeTimer = setTimeout(() => {
            this.easyBuyWaitingStep = (this.easyBuyWaitingStep + 1) % 6
            this.easyBuyWaitingSeconds = 60
            this.easyBuyWaitingChanging = false
        }, 450)
    },

    startEasyBuyTimer() {
        this.stopEasyBuyTimer()
        this.updateEasyBuyTimer()
        this.easyBuyTimer = setInterval(() => this.updateEasyBuyTimer(), 1000)
    },

    stopEasyBuyTimer() {
        if (this.easyBuyTimer) clearInterval(this.easyBuyTimer)
        this.easyBuyTimer = null
    },

    async requestAnotherEasyBuyNumber() {
        if (!this.easyBuyCanTryAnotherNumber || this.easyBuyTryAnotherLoading) return false
        this.easyBuyTryAnotherLoading = true
        this.easyBuyOrderError = ''
        try {
            const response = await axios.post('/api/easy_buy.php?method=ANOTHER_NUMBER')
            const payload = response?.data || {}
            if (payload.code !== 0 || !payload.data?.order?.phonenumber) throw new Error(payload.message || 'Failed to get another number.')
            this.easyBuyOrder = payload.data.order
            this.easyBuySmsWaitStartedAt = Date.now()
            this.easyBuyNumberCopied = false
            this.resetEasyBuyWaitingMessages()
            this.startEasyBuyTimer()
            return true
        } catch (error) {
            this.easyBuyOrderError = error?.response?.data?.message || error.message || 'Failed to get another number.'
            return false
        } finally { this.easyBuyTryAnotherLoading = false }
    },

    async startEasyBuyPayment() {
        const method = this.easyBuySelectedPaymentMethodData
        if (!method?.id || this.easyBuyInvoiceLoading) return false
        this.easyBuyInvoiceLoading = true
        this.easyBuyPaymentError = ''
        const paymentWindow = window.open('about:blank', '_blank')
        try {
            const response = await axios.post('/api/easy_buy.php?method=START_PAYMENT', { pid: method.id })
            const payload = response?.data || {}
            if (payload.code !== 0 || !payload.data?.html) throw new Error(payload.message || 'Failed to create payment invoice.')
            this.easyBuyOrder = payload.data.order || this.easyBuyOrder
            this.easyBuyPaymentStatusText = 'Waiting for payment confirmation…'
            this.startEasyBuyOrderPolling()
            this.submitEasyBuyInvoiceToWindow(payload.data.html, paymentWindow)
            return true
        } catch (error) {
            paymentWindow?.close()
            this.easyBuyPaymentError = error?.response?.data?.message || error.message || 'Failed to create payment invoice.'
            return false
        } finally { this.easyBuyInvoiceLoading = false }
    },

    submitEasyBuyInvoiceToWindow(html, paymentWindow) {
        const container = document.createElement('div')
        container.innerHTML = html
        const form = container.querySelector('form')
        const link = container.querySelector('a')
        if (form) {
            form.target = paymentWindow?.name || '_blank'
            form.style.display = 'none'
            document.body.appendChild(form)
            form.submit()
            form.remove()
        } else if (link?.href) {
            if (paymentWindow) paymentWindow.location.href = link.href
            else window.open(link.href, '_blank', 'noopener')
        } else {
            paymentWindow?.close()
            throw new Error('Payment form is unavailable.')
        }
    },

    startEasyBuyOrderPolling() {
        this.stopEasyBuyOrderPolling()
        this.easyBuyCheckOrder()
        this.easyBuyPaymentStatusTimer = setInterval(() => this.easyBuyCheckOrder(), 5000)
    },

    stopEasyBuyOrderPolling() {
        if (this.easyBuyPaymentStatusTimer) clearInterval(this.easyBuyPaymentStatusTimer)
        this.easyBuyPaymentStatusTimer = null
    },

    async easyBuyCheckOrder() {
        try {
            const response = await axios.get('/api/easy_buy.php?method=CHECK_ORDER')
            const payload = response?.data || {}
            if (payload.code !== 0 || !payload.data?.order) return false
            this.easyBuyOrder = payload.data.order
            if (this.easyBuyOrder.completed) {
                this.easyBuyPaymentStatusText = 'Payment confirmed. Your SMS has been revealed.'
                this.stopEasyBuyOrderPolling()
                this.stopEasyBuyTimer()
                return true
            }
            // Once the SMS is stored, polling is no longer useful until the user starts payment.
            // startEasyBuyPayment() starts it again to wait for the payment confirmation.
            if (this.easyBuyOrder.sms_ready && !this.easyBuyOrder.payment_id) {
                this.easyBuyPaymentStatusText = 'SMS received. It will be revealed after payment.'
                this.stopEasyBuyOrderPolling()
                return true
            }
            this.easyBuyPaymentStatusText = this.easyBuyOrder.payment_paid ? 'Payment confirmed. Waiting for SMS…' : (this.easyBuyOrder.sms_ready ? 'SMS received. It will be revealed after payment.' : 'Waiting for SMS…')
        } catch (error) { console.log('Easy Buy order check failed:', error) }
        return false
    },

    async loadEasyBuyTopupMethods() {
        if (!this.easyBuyRegisteredFlow || this.easyBuyTopupLoading) return this.easyBuyTopupMethods

        this.easyBuyTopupLoading = true
        this.easyBuyTopupError = ''
        try {
            const response = await axios.get('/api/paysys_api.php?method=get_paysys_list')
            const payload = response?.data || {}
            if (!payload.status || !payload.data) throw new Error(payload.errormsg || $L('ords.easy_buy_no_methods'))

            const methods = []
            const collectMethods = (items) => {
                if (!Array.isArray(items)) return
                items.forEach((item) => {
                    if (Array.isArray(item?.paysys_list)) {
                        collectMethods(item.paysys_list)
                    } else if (item?.id && item?.type) {
                        methods.push(item)
                    }
                })
            }

            collectMethods(payload.data.no_cat)
            collectMethods(payload.data.with_cat)

            const allowedTypes = ['wata-credit-cards', 'fride-credit-cards']
            this.easyBuyTopupMethods = methods.filter((method) => allowedTypes.includes(method.type))

            if (!this.easyBuyTopupMethods.length) {
                throw new Error($L('ords.easy_buy_no_methods'))
            }

            const currentIsAvailable = this.easyBuyTopupMethods.some((method) => String(method.id) === String(this.easyBuySelectedTopupMethod))
            if (!currentIsAvailable) this.selectEasyBuyTopupMethod(this.easyBuyTopupMethods[0].id)
            return this.easyBuyTopupMethods
        } catch (error) {
            this.easyBuyTopupMethods = []
            this.easyBuySelectedTopupMethod = null
            this.easyBuyTopupError = error?.response?.data?.errormsg || error.message || $L('ords.easy_buy_no_methods')
            return []
        } finally {
            this.easyBuyTopupLoading = false
        }
    },

    selectEasyBuyTopupMethod(methodId) {
        this.easyBuySelectedTopupMethod = methodId
        this.easyBuyTopupError = ''
        const method = this.easyBuyTopupMethods.find((item) => String(item.id) === String(methodId))
        const minimum = Math.max(Number(this.easyBuyAmountValue || 0), Number(method?.min_amount || 0))
        const currentAmount = Number(this.easyBuyTopupAmount)
        if (!Number.isFinite(currentAmount) || currentAmount < minimum) this.easyBuyTopupAmount = minimum.toFixed(2)
    },

    startEasyBuyBalancePolling() {
        if (!this.easyBuyRegisteredFlow) {
            this.stopEasyBuyBalancePolling()
            return
        }
        this.stopEasyBuyBalancePolling()
        this.checkEasyBuyBalance()
        this.easyBuyBalancePollingTimer = setInterval(() => this.checkEasyBuyBalance(), 30000)
    },

    stopEasyBuyBalancePolling() {
        if (this.easyBuyBalancePollingTimer) clearInterval(this.easyBuyBalancePollingTimer)
        this.easyBuyBalancePollingTimer = null
        this.easyBuyBalancePollingInFlight = false
    },

    async checkEasyBuyBalance() {
        if (!this.easyBuyRegisteredFlow) {
            this.stopEasyBuyBalancePolling()
            return false
        }
        if (this.easyBuyBalancePollingInFlight) return false
        this.easyBuyBalancePollingInFlight = true
        try {
            const form = new FormData()
            form.append('method', 'GET_USER_BALANCE')
            const response = await axios.post('/sms_api/orders.php?n=easy-buy-balance', form)
            const payload = response?.data?.response || {}

            if (!payload.res) {
                if (payload.error === 'auth_required') this.stopEasyBuyBalancePolling()
                return false
            }

            const balance = Number(payload.data?.balance)
            if (!Number.isFinite(balance)) return false

            if (balance > 0) {
                this.stopEasyBuyBalancePolling()
                this.completeEasyBuyWithStandardOrder()
                return true
            }
        } catch (error) {
            console.warn('Easy Buy balance check failed:', error)
        } finally {
            this.easyBuyBalancePollingInFlight = false
        }
        return false
    },

    async completeEasyBuyWithStandardOrder() {
        if (this.easyBuyStandardOrderStarting || !this.isUserLoggedIn || !this.currServOpt || this.currServOpt === 'min' || !this.currentCountry) return false

        this.easyBuyStandardOrderStarting = true
        // Сначала полностью обновляем страницу без Easy Buy. Только на свежей
        // странице штатный orders.js создаст заказ — так мы не прерываем
        // переход к платёжной системе и не работаем со старым состоянием Vue.
        this.easyBuyRegistered = false
        this.easyBuyRegistrationModal = false
        const url = new URL(window.location.href)
        url.searchParams.delete('easy_buy_registered')
        url.searchParams.delete('easy_buy_registration_notice')
        url.searchParams.set('easy_buy_start_order', '1')
        window.location.assign(url.toString())
        return true
    },

    async createEasyBuyTopupInvoice() {
        if (!this.easyBuyCanCreateTopupInvoice) return false

        const method = this.easyBuySelectedTopupMethodData
        const amount = Math.max(Number(this.easyBuyTopupAmountValue || 0), Number(this.easyBuyTopupMinimumAmount || 0))
        const paymentWindow = window.open('about:blank', '_blank')

        this.easyBuyTopupInvoiceLoading = true
        this.easyBuyTopupRedirecting = false
        this.easyBuyTopupError = ''
        try {
            const form = new FormData()
            form.append('amount', amount.toFixed(2))
            form.append('pid', method.id)

            const response = await axios.post('/api/paysys_api.php?method=create_invoice', form)
            const payload = response?.data || {}
            if (!payload.status || !payload.data || payload.data === 'disabled') {
                throw new Error(payload.errormsg || $L('ords.somethingWrong'))
            }

            if (payload.data.type === 'risk_check' && payload.data.url) {
                this.easyBuyTopupRedirecting = true
                this.startEasyBuyBalancePolling()
                if (paymentWindow) paymentWindow.location.href = payload.data.url
                else window.location.href = payload.data.url
                return true
            }

            this.submitEasyBuyInvoiceToWindow(payload.data, paymentWindow)
            this.easyBuyTopupRedirecting = true
            this.startEasyBuyBalancePolling()
            return true
        } catch (error) {
            paymentWindow?.close()
            this.easyBuyTopupRedirecting = false
            this.easyBuyTopupError = error?.response?.data?.errormsg || error.message || $L('ords.somethingWrong')
            return false
        } finally {
            this.easyBuyTopupInvoiceLoading = false
        }
    },
}
